import PropTypes from "prop-types";
import React from "react";

import { inputPropTypes } from "@swa-ui/core";
import { TextFormField } from "@swa-ui/form";
import i18n from "@swa-ui/locale";

import { PREFERRED_FIRST_NAME_SCHEMA_FIELD_NAME } from "./PreferredFirstNameFormField.schema";

/**
 * PreferredFirstNameFormField facilitates the input of a preferred first name.
 */

export const PreferredFirstNameFormField = (props) => {
  const {
    componentProps,
    description,
    disabled,
    name = PREFERRED_FIRST_NAME_SCHEMA_FIELD_NAME,
  } = props;

  return <TextFormField {...getTextFormFieldProps()} />;

  function getTextFormFieldProps() {
    return {
      componentProps: {
        "aria-label": i18n("PreferredFirstNameFormField__ARIA"),
        ...componentProps,
      },
      description,
      disabled,
      label: i18n("PreferredFirstNameFormField__LABEL"),
      name,
    };
  }
};

export const preferredFirstNameFormFieldPropTypes = {
  /** Component props for input component. */
  componentProps: PropTypes.shape(inputPropTypes),

  /** Indicates whether the field is disabled. */
  disabled: PropTypes.bool,

  /** Form field name used in schema validation and service call payload. */
  name: PropTypes.string,
};

PreferredFirstNameFormField.propTypes = preferredFirstNameFormFieldPropTypes;
